import { SourceValidator, UrlParser } from "@authory-packages/core";

export const getSlug = (url: string) => {
    const domain = UrlParser.extractDomain(url);
    const sourceType = SourceValidator.getSourceTypeFromDomain(domain || "");
    return SourceValidator.createSlug(url, null, sourceType) || "";
};
